import { render, staticRenderFns } from "./CopySimple.vue?vue&type=template&id=6609b14f&"
import script from "./CopySimple.vue?vue&type=script&lang=js&"
export * from "./CopySimple.vue?vue&type=script&lang=js&"
import style0 from "./CopySimple.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports